import { useQuery } from '@tanstack/react-query'
import { dataSource } from '../../service/domain/_service.config'

export function useUserByID(userID: string | null) {
  return useQuery({
    queryKey: ['user', userID],
    queryFn: async () => {
      if (!userID) return null
      return dataSource.getUser(userID)
    },
    enabled: !!userID,
    retry: false,
  })
}

